
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[league]/shotquality-scores",
      function () {
        return require("private-next-pages/[league]/shotquality-scores/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[league]/shotquality-scores"])
      });
    }
  